import { MoneyOff, AccountBalance, Campaign } from "@mui/icons-material";

/* ── Priority / Weight ──────────────────────────────── */

export const getWeight = (each) => {
  const p = Number(each.priority) || 0;
  const c = Number(each.consider) || 0;
  const f = Number(each.frequency) || 0;
  const raw = p + c + f;
  // Legacy data may have individual values > 10 (old scale)
  if (p > 10 || c > 10 || f > 10) {
    const maxOld = 3121;
    return Math.max(1, Math.min(10, Math.round((raw / maxOld) * 10)));
  }
  return Math.max(1, Math.min(10, Math.round((raw / 11) * 10)));
};

export const getWeightLabel = (w) => {
  if (w >= 8) return "Critical";
  if (w >= 5) return "High";
  if (w >= 3) return "Medium";
  return "Low";
};

export const WEIGHT_COLOR = (w) =>
  w >= 8 ? "error" : w >= 5 ? "warning" : "success";

/* ── Status ─────────────────────────────────────────── */

export const STATUS_CONFIG = {
  open: { label: "Open", color: "info" },
  "in-progress": { label: "In Progress", color: "warning" },
  resolved: { label: "Resolved", color: "success" },
  closed: { label: "Closed", color: "default" },
};

/* ── Project Type ───────────────────────────────────── */

export const PROJECT_TYPE_META = {
  "no-cost":    { label: "No Cost",          icon: MoneyOff,       color: "#2e7d32", chipColor: "success" },
  "corpus":     { label: "Fund from Corpus", icon: AccountBalance, color: "#6a1b9a", chipColor: "secondary" },
  "fund-raise": { label: "Fund Raise",       icon: Campaign,       color: "#e65100", chipColor: "warning" },
};

export const PROJECT_TYPE_CHIP = {
  "no-cost":    { label: "No Cost",    color: "success", icon: MoneyOff },
  "corpus":     { label: "Corpus",     color: "secondary", icon: AccountBalance },
  "fund-raise": { label: "Fund Raise", color: "warning", icon: Campaign },
};
